import { useCallback } from "react";

import { ConfigInput } from "types/generated";
import { createDefaultMutationHook } from "hooks/useMutationHandler";
import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";

import { INTENT_PROJECT_CONFIG_UPDATE } from "./gql";

const updateConfigHook = createDefaultMutationHook(INTENT_PROJECT_CONFIG_UPDATE);

const useIntentProjectConfigUpdate = () => {
  const { reportSuccess } = useTypedContext(FlashContext);

  const [updateConfig, { loading, error }] = updateConfigHook({
    refetchQueries: ["GetIntentProject", "GetIntentProjectConfig"],
  });

  const updateConfigToIntentProject = useCallback(
    (intentProjectId: string, config: ConfigInput, callback?: () => void) => {
      updateConfig({ project: intentProjectId, config: config }, (data) => {
        if (data?.intentProjectConfigUpdate?.id) {
          reportSuccess({ message: "Config was successfully updated." });
          callback?.();
        }
      });
    },
    [updateConfig, reportSuccess]
  );

  return {
    updateConfigToIntentProject,
    loading,
    error,
  };
};

export default useIntentProjectConfigUpdate;
